const french = {
    search_title: 'Chercher',
    search_everything: 'Trouvez tout autour de Nara',
    search_accommodation: 'Trouver des hébergements autour de Nara',
    search_activity: 'Trouver une activité autour de Nara',
    search_product: 'Trouver des produits autour de Nara',
    search_restaurant: 'Trouver des restaurants autour de Nara',
    search_subtitle: `Trouver des activités autour de Nara`,
    search_subsubtitle: `Vous pouvez ajouter n'importe quel service / produit à la liste de souhaits.`,
    search_button: `Chercher`,
    search_price_range: 'Échelle des prix',
    search_all_categories: 'toutes catégories',
    accommodation: 'Hébergement',
    activity: 'Activité',
    restaurant: 'Le restaurant',
    produce: 'Produire',
    search_keyword: 'Tapez les mots-clés',
    wishlist_empty: 'Le panier est vide',
    close: 'Fermer',
    check_availability: 'Continuer le Paiement',
    load_more: 'Charger plus',
    loading: ' Chargement ...',
    view_details: 'Vue',
    basic_info: 'Informations de base',
    map: 'Carte',
    details: 'Détails',
    home: 'Domicile',
    list: 'Lister',
    name: 'Nom',
    address: 'Adresse',
    phone: 'Téléphoner',
    website: 'Site Web',
    email: 'E-mail',
    fax: 'Fax',
    from: 'De',
    price: 'Prix',
    rate: 'Taux',
    add_to_wishlist: 'Reserve maintenant',
    under_maintenance: 'Under Maintenance',
    remove_from_wishlist: 'Retirer le livre',
    wishlist: 'Chariot',
    not_available: 'Indisponible',
    night: 'Nuit',
    guest: 'Invité',
    item: 'Objet',
    date: 'Date',
    read_more: 'lire la suite',
    read_less: 'lire moins',
    check_price_availability: 'Vérifier le prix et la disponibilité',
    available_products: 'Produits disponibles',
    start_time: 'Heure de début',
    different_time: 'ou choisissez une autre heure',
    dairy: 'Laitière',
    sweet: 'Douce',
    wine: 'Vin',
    quantity: 'Quantité',
    request_to_book: 'Demande de réservation',
    sort_by: 'Sort By',
    name_az: 'Name - Ascending',
    name_za: 'Name - Descending',
    price_az: 'Price - Ascending',
    price_za: 'Price - Descending',
    extras: 'Extras',
    no_public_website: 'No Public Website',
    no_public_email: 'No Public Email,',
    firstName: 'First Name',
    lastName: 'Last Name',
    userEmail: 'Email',
    conf_email: 'Re-Type Email',
    mobile: 'Mobile/Cell Phone',
    city: 'Suburb/City',
    state: 'State/Country',
    zipcode: 'Post Code/Zip',
    country: 'Country',
    marketing: 'Marketing',
    business: 'Business',
    specialRequest: 'Special Request Note',
    is_required: ' is required',
    is_not_the_same: ' is not the same',
    is_not_a_valid_email: ' is not valid',
    must_be_a_number: ' must be a number',
    select_country: 'Select Country',
    submit: 'Submit',
    customer_detail: 'Customer Detail',
    booking_information: 'Booking Information',
    product: 'Product',
    options_costs: 'Options/Costs',
    totals: 'Totals',
    adult: 'Adult(s)',
    check_in: 'Check In',
    check_out: 'Check Out',
    back_to_nara: 'Back To Nara',
    booking_req_detail_wait: 'Booking Request Details - awaiting confirmation',
    booking_req_instructions: "You'll receive an email within 24 hours to confirm if your booking request has been accepted by the operator. Payment is not due until your booking request has been accepted.",
    request_date: 'Request Date (UTC)',
    booking_reference: 'Booking Reference',
    booked_by: 'Booked by',
    supplier_information: 'Supplier Information',
    total_gst: 'Total (inc. GST)',
    amount_paid: 'Amount Paid (inc. GST)',
    amount_owing: 'Amount Owing (inc. GST)',
};
export default french;
